export const UserDisplayFormat = Object.freeze({
	FirstName_LastName: 1,
	LastName_FirstName: 2,
	Email: 3,
	Username: 4,
	FirstName_LastName_Email: 5,
	LastName_FirstName_Email: 6,
	FirstName_LastName_Username: 7,
	LastName_FirstName_Username: 8,
});
